import { render, staticRenderFns } from "./accReportAccount.vue?vue&type=template&id=63f48db8&"
import script from "./accReportAccount.vue?vue&type=script&lang=js&"
export * from "./accReportAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports